var render = function render(){var _vm=this,_c=_vm._self._c;return _c('input',{staticClass:"input_form",class:_vm.className,attrs:{"type":_vm.type,"placeholder":_vm.placeholder},domProps:{"value":_vm.value},on:{"input":_vm.handleInput}})
}
var staticRenderFns = []

export { render, staticRenderFns }